(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4132],{

/***/ 44132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero063": function() { return /* binding */ Hero063; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14258);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52853);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87900);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87367);
/* harmony import */ var _Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71733);
/* harmony import */ var _Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var Hero063 = function(param) {
    var payload = param.payload;
    var ref, ref1, ref2, ref3;
    var ref4;
    var headline = (ref4 = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    var subtitle = (ref5 = payload === null || payload === void 0 ? void 0 : payload.subtitle) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6;
    var description = (ref6 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref6 !== void 0 ? ref6 : "";
    var ref7;
    var buttonText = (ref7 = payload === null || payload === void 0 ? void 0 : (ref = payload.request) === null || ref === void 0 ? void 0 : ref.buttonText) !== null && ref7 !== void 0 ? ref7 : "";
    var ref8;
    var form = (ref8 = payload === null || payload === void 0 ? void 0 : (ref1 = payload.request) === null || ref1 === void 0 ? void 0 : ref1.form) !== null && ref8 !== void 0 ? ref8 : {};
    var ref9;
    var type = (ref9 = payload === null || payload === void 0 ? void 0 : (ref2 = payload.request) === null || ref2 === void 0 ? void 0 : ref2.type) !== null && ref9 !== void 0 ? ref9 : "form";
    var ref10;
    var link = (ref10 = payload === null || payload === void 0 ? void 0 : (ref3 = payload.request) === null || ref3 === void 0 ? void 0 : ref3.link) !== null && ref10 !== void 0 ? ref10 : "";
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_3__/* .buildWidgetInstanceId */ .G1)("063", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__/* .WIDGETS_REGISTRY.HERO */ .R.HERO);
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().query;
    var ref11 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useToggle */ .OT)(), opened = ref11.opened, onOpen = ref11.onOpen, onClose = ref11.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().block),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().top),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Heading1 */ .nL, {
                                className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headline),
                                color: "dark",
                                children: headline
                            }),
                            type === "form" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Action */ .aU, {
                                onClick: onOpen,
                                className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().play),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                            className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().icon),
                                            name: "arrow_right"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                        color: "brand",
                                        appearance: "bigger",
                                        children: buttonText
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .PageLink */ .H_, {
                                className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().play),
                                link: link,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                            className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().icon),
                                            name: "arrow_right"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                        color: "brand",
                                        appearance: "bigger",
                                        children: buttonText
                                    })
                                ]
                            }),
                            opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ModalWrapper */ .AB, {
                                onCloseModal: onClose,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                                    item: form,
                                    metaData: {
                                        page: query.slug
                                    },
                                    instanceId: instanceId,
                                    onReset: onClose
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().bottom),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().text),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                    color: "brand",
                                    className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().subtitle),
                                    children: subtitle
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, {
                                value: description,
                                color: "dark",
                                className: (_Hero063_module_scss__WEBPACK_IMPORTED_MODULE_8___default().description)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero063);


/***/ }),

/***/ 71733:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero063_wrapper__arUzi","top":"Hero063_top__aQHBc","bottom":"Hero063_bottom__qW9sb","headline":"Hero063_headline__Wt9sG","text":"Hero063_text__ip7Jb","subtitle":"Hero063_subtitle__IQMon","description":"Hero063_description__brIar","play":"Hero063_play__i_QZE","arrow":"Hero063_arrow__0PFQT","icon":"Hero063_icon__bhn73"};

/***/ })

}]);